import banner from '../assets/imgs/why.webp'
import one from '../assets/imgs/1.webp'
import two from '../assets/imgs/2.webp'
import three from '../assets/imgs/3.webp'
import four from '../assets/imgs/4.webp'
import five from '../assets/imgs/5.webp'
import six from '../assets/imgs/6.webp'

import React, { useEffect } from 'react'
import AOS from 'aos';
import 'aos/dist/aos.css';
import Whatsapp from './Whatsapp'


function WhySamriddhi() {

    useEffect(() => {
        AOS.init({
            duration: 1000, // Animation duration in milliseconds
            once: true, // Whether animation should happen only once on scroll
        });
    }, []);

    return (

        <>
            <div className='why-hero-section'>

                <img src={banner} loading="lazy"></img>

            </div>

            <div className='why-info-container'>
                <div className='enter-info'  data-aos="fade-up" data-aos-delay="100" >
                    <p>Samriddhi Group offers a real estate entrepreneurship career program that emphasizes collaboration and growth. We believe in the concept that “network = net worth” and aim to provide opportunities for learning, earning, and entrepreneurship with zero capital investment and substantial income potential.</p>
                </div>

                <h1  data-aos="fade-up" data-aos-delay="200">Career Options</h1>

                <div className='career-option'>
                    <div className='rect'  data-aos="fade-up" data-aos-delay="100">

                        <div>
                            <h2 className='num'>01</h2>
                        </div>
                        <div>
                            <img src={one} loading="lazy"></img>
                        </div>


                        <div>
                            <h2>Sales Partner​</h2>
                        </div>

                    </div>
                    <div className='rect'  data-aos="fade-up" data-aos-delay="400">
                        <div>
                            <h2 className='num'>02</h2>
                        </div>

                        <div><img src={two} loading="lazy"></img></div>
                        <div> <h2>Sole Selling Partner​</h2></div>



                    </div>
                    <div className='rect'  data-aos="fade-up" data-aos-delay="800">
                        <div>
                            <h2 className='num'>03</h2>
                        </div>

                        <div><img src={three} loading="lazy"></img></div>
                        <div> <h2>Team Leader ​</h2></div>


                    </div>
                    <div className='rect'  data-aos="fade-up" data-aos-delay="1200">
                        <div>
                            <h2 className='num'>04</h2>
                        </div>

                        <div><img src={four} loading="lazy"></img></div>
                        <div> <h2>Investors and project partners
                        </h2></div>


                    </div>
                    <div className='rect'  data-aos="fade-up" data-aos-delay="1400">
                        <div>
                            <h2 className='num'>05</h2>
                        </div>

                        <div>
                            <img src={five} loading="lazy"></img>
                        </div>
                        <div>
                            <h2>Builders and <br></br>
                                Developers Partner</h2>
                        </div>


                    </div>
                    <div className='rect'  data-aos="fade-up" data-aos-delay="1800">
                        <div>
                            <h2 className='num'>06</h2>
                        </div>

                        <div> <img src={six} loading="lazy"></img></div>
                        <div>  <h2>Real Estate Trainer</h2></div>


                    </div>


                </div>

                <div className='car-msg'  data-aos="fade-up" data-aos-delay="100">
                    <h2>Unlock Your Potential in Real Estate!</h2>
                    <h3>ready to make your mark in the booming real estate industry? </h3>
                    <h4>Join our “9-Day Intensive Real Estate Training” and take your career to the next level!</h4>
                </div>

                <div className='get mt'  data-aos="fade-up" data-aos-delay="100">
                    <div>
                        <h2>What Will You Learn?</h2>
                        <p>Learn from expert trainers</p>
                        <ul>
                            <li>How to become No. 1 in Real Estate</li>
                            <li>Characteristics of successful individuals
                            </li>
                            <li>How to become the top, best, and fastest businessman in Real Estate
                            </li>
                            <li>Essential Commandments and the 3 Door Formula
                            </li>
                            <li>6 Laws to achieve No. 1 status
                            </li>
                            <li>Lead Generation and Marketing Strategies
                            </li>
                            <li>Sales Process and Customer Handling
                            </li>
                            <li>And much more!</li>
                        </ul>
                    </div>
                    <div>
                        <h2>Benefits of Working with Us</h2>
                        <ul>
                            <li>
                                Learn, Earn, Become an entrepreneur and Create Entrepreneurial Plans
                            </li>
                            <li>
                                Free Online Registration Facility
                            </li>
                            <li>
                                FREE Real Estate Business Training

                            </li>
                            <li>No Investment and No Risk
                            </li>
                            <li>Part-Time / Full-Time as per Your Schedule
                            </li>
                            <li>Work From Home / Anywhere
                            </li>
                            <li>Regular Product Training
                            </li>
                            <li>Company Support System
                            </li>
                            <li>Sales Support System
                            </li>
                            <li>Site Visit Support
                            </li>
                        </ul>
                    </div>
                </div>

                <div className='car-msg car-msg2 mt'  data-aos="fade-up" data-aos-delay="100">
                    <h2>What Will You Get?</h2>
                    <h3><span>Free Training: </span>9-day free Training </h3>
                    <h3><span>Practical Experience: </span>Opportunity to work on projects and earn while you learn. </h3>
                    <h3><span>Expert Guidance: </span>Comprehensive training with experienced trainers. </h3>

                </div>



            </div>

            <Whatsapp />


        </>

    )

}

export default WhySamriddhi